import { PersonalizedSlipBlockType } from "../personalized-slip/personalized-slip-definition";
import { CARRIER_LABEL_FIELDS_HEIGHT_INCHES } from "./carrier-label-fields";
import {
  SHIPPING_LABEL_CSS_PIXELS_PER_INCH,
  SHIPPING_LABEL_HEIGHT_INCHES,
  SHIPPING_LABEL_WIDTH_INCHES,
} from "./shipping-label-layout";
import { ShippingLabelTextBlock } from "./shipping-label-template-definition";

const LEGACY_STRIP_FONT_SIZE_PX = 14;
const LABEL_FIELDS_PADDING_LEFT_PX = SHIPPING_LABEL_CSS_PIXELS_PER_INCH / 8;

export const LABEL_FIELDS_BLOCK_ID = "label-fields";

/** The largest font whose glyph box (about 1.2em) still fits the strip. */
export const LABEL_FIELDS_MAX_FONT_SIZE_PX = Math.floor(
  (CARRIER_LABEL_FIELDS_HEIGHT_INCHES * SHIPPING_LABEL_CSS_PIXELS_PER_INCH) /
    1.2,
);

/**
 * A text block that prints the toggled label fields like the legacy strip: the
 * same text, font, size, line height, and position. It sits an eighth of an
 * inch in so a label's rounded corner can't clip it.
 */
export function buildLabelFieldsBlock(): ShippingLabelTextBlock {
  const heightPx =
    CARRIER_LABEL_FIELDS_HEIGHT_INCHES * SHIPPING_LABEL_CSS_PIXELS_PER_INCH;
  return {
    type: PersonalizedSlipBlockType.TEXT,
    id: LABEL_FIELDS_BLOCK_ID,
    x: 0,
    y:
      (SHIPPING_LABEL_HEIGHT_INCHES - CARRIER_LABEL_FIELDS_HEIGHT_INCHES) *
      SHIPPING_LABEL_CSS_PIXELS_PER_INCH,
    width: SHIPPING_LABEL_WIDTH_INCHES * SHIPPING_LABEL_CSS_PIXELS_PER_INCH,
    height: heightPx,
    zIndex: 0,
    rotation: 0,
    side: "front",
    text: "<p>{{ label_fields }}</p>",
    autoFitText: false,
    singleLine: true,
    monospace: true,
    fontSize: LEGACY_STRIP_FONT_SIZE_PX,
    lineHeight: 1,
    fontColor: "#000000",
    linkColor: "#000000",
    padding: {
      top: 0,
      right: 0,
      bottom: 0,
      left: LABEL_FIELDS_PADDING_LEFT_PX,
    },
  };
}
